// src/SetPassword.js
import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Layout from "./Components/Layout";
import { api } from "./lib/api";
import styles from "./styles/Auth.module.css";
export default function SetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    if (!password || password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }

    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      const { data } = await api.post("auth/set-password", {
        token,
        password,
      });

      if (!data?.ok) {
        throw new Error(data?.message || "Failed");
      }

      setSuccess(true);
      setTimeout(() => nav("/login"), 2000);
    } catch (e) {
      setError(e?.response?.data?.message || "Link expired or invalid");
      setLoading(false);
    }
  };

  return (<div className={styles.container}>
    <Layout title="Set Password">
      <div style={{ maxWidth: 420, margin: "60px auto", padding: 20 }}>
        <h2>Set your password</h2>

        {success ? (
          <p style={{ color: "green" }}>
            Password set successfully. Redirecting to login…
          </p>
        ) : (
          <form onSubmit={submit}>
            {error && <p style={{ color: "#b00020" }}>{error}</p>}

            <input
              type="password"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={input}
            />

            <input
              type="password"
              placeholder="Confirm password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              style={input}
            />

            <button type="submit" disabled={loading} style={btn}>
              {loading ? "Saving…" : "Set password"}
            </button>
          </form>
        )}
      </div>
    </Layout></div>
  );
}

const input = {
  width: "100%",
  padding: 12,
  marginBottom: 12,
  borderRadius: 8,
  border: "1px solid #ccc",
};

const btn = {
  width: "100%",
  padding: 12,
  borderRadius: 10,
  border: "none",
  background: "#c47a00",
  color: "#fff",
  fontWeight: 700,
};
